module.exports = __webpack_public_path__ + "static/media/icon-popup-invite.4f532285.png";